import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorToast, maskEmail, successToast } from '../../utils';
import { confirmUser, logoutUser, resendConfirmUser } from '../../store/auth/authActions';
import useDigitInput from 'react-digit-input';

export const ConfirmEmail = () => {
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.auth);
    const [resendLoading, setResendLoading] = useState(false);
    const maskedEmail = maskEmail(user.email);
    const [value, onChange] = useState('');
    const digits = useDigitInput({
        acceptedCharacters: /^[0-9]$/,
        length: 6,
        value,
        onChange,
    });
    const confirmEmailAction = (e) => {
        e.preventDefault();
        e.stopPropagation();

        dispatch(confirmUser({
            code: value,
            userId: user._id,
        }))
            .unwrap()
            .then(() => {
                successToast("Email Confirmed")
            })
            .catch((errorData) => {
                errorToast(errorData.error);
            });
    };

    const resendCode = (e) => {
        e.preventDefault() 
        setResendLoading(true)
        dispatch(resendConfirmUser({
            userId: user._id,
        }))
            .unwrap()
            .then(() => {
                setResendLoading(false);
                successToast("Code Sent Again.")
            })
            .catch((errorData) => {
                setResendLoading(false);
                errorToast(errorData.error);
            });
    }

    return (
        <>
        <form onSubmit={confirmEmailAction} className='space-y-4 text-center'>
            <div>
                <h1 className='mb-1 text-center text-nt-blue'>Confirm Email</h1>
                <p className='text-sm text-nt-grey'>Enter the 6-digit code sent to <span className='font-medium'>{maskedEmail}</span>.</p>
            </div>
            <div className='rounded-xl border border-slate-200 bg-slate-50 p-4'>
                <div className="relative">
                    <div className={`items-center justify-center flex`}>
                        <input className='nt-auth-otp-input' inputMode="decimal" autoFocus {...digits[0]} />
                        <input className='nt-auth-otp-input' inputMode="decimal" {...digits[1]} />
                        <input className='nt-auth-otp-input' inputMode="decimal" {...digits[2]} />
                        <input className='nt-auth-otp-input' inputMode="decimal" {...digits[3]} />
                        <input className='nt-auth-otp-input' inputMode="decimal" {...digits[4]} />
                        <input className='nt-auth-otp-input' inputMode="decimal" {...digits[5]} />
                    </div>
                </div>
            </div>
            <button disabled={value.trim().length !== 6 || loading} type="submit" className="w-full rounded-xl bg-nt-blue px-4 py-2.5 text-white transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-70">
                {loading ? 'Loading...' : 'Confirm'}
            </button>
            <button className="bg-transparent text-sm text-nt-blue disabled:opacity-70" disabled={resendLoading} onClick={(e) => resendCode(e)}>{resendLoading ? "Resending..." : "Resend code"}</button>
        </form>
            <button role='button' className='mx-auto mt-2 block text-sm text-nt-grey' onClick={() => dispatch(logoutUser())}>Logout if this is not your email</button>
        
        </>
    );
};
